import { render } from "./vue-hcaptcha.vue?vue&type=template&id=6b8568d6"
import script from "./vue-hcaptcha.vue?vue&type=script&lang=js"
export * from "./vue-hcaptcha.vue?vue&type=script&lang=js"
script.render = render

export default script